export class SignalBuffer {
  constructor(settings) {
    this.settings = settings;
  }

  init(){}

  getPointX(graphicDataIndex) {
    let pointIndex = this.graphicDataBuffer[graphicDataIndex].graphicIndex;
    if (this.isColumnMode) {
      return pointIndex;
    } else {
      if (pointIndex * 4 >= this.pointBuffer.length) {
        return undefined;
      }
      return this.pointBuffer[pointIndex * 4];
    }
  }

  getFirstGraphicDataPoint(x) {
    let bufferIndex = this.getFirstGraphicDataIndex(x);
    if (bufferIndex === undefined) {
      return undefined;
    }
    return this.graphicDataBuffer[bufferIndex];
  }

  getLastGraphicDataPoint(x) {
    let bufferIndex = this.getLastGraphicDataIndex(x);
    if (bufferIndex === undefined) {
      return undefined;
    }
    return this.graphicDataBuffer[bufferIndex];
  }

  getFirstGraphicDataIndex(x) {
    return this.isColumnMode ? this.getFirstColumnGraphicDataIndex(x) : this.searchLinearGraphicDataIndex(x);
  }

  getLastGraphicDataIndex(x) {
    return this.isColumnMode ? this.getLastColumnGraphicDataIndex(x) : this.searchLinearGraphicDataIndex(x);
  }

  searchLinearGraphicDataIndex(x) {
    for (let i = 0; i < this.pointBuffer.length; i += 4) {
      if (this.pointBuffer[i + 2] >= x) {
        if (this.pointBuffer[i] > x) {
          return undefined;
        }
        if (Math.abs(this.pointBuffer[i] - x) < Math.abs(this.pointBuffer[i + 2] - x)) {
          return i / 4;
        }
        return i / 4 + 1;
      }
    }
    return undefined;
  }

  getLastValidGraphicDataIndex() {
    if (this.graphicDataIndex < 0) {
      return undefined;
    }
    if (this.graphicDataIndex < this.graphicDataBuffer.length - 1 && this.graphicDataBuffer[this.graphicDataIndex + 1].graphicIndex < 0) {
      return this.graphicDataIndex;
    }
    return this.graphicDataBuffer.length - 1;
  }

  getLastValidPointX() {
    const graphicDataIndex = this.getLastValidGraphicDataIndex();
    if (graphicDataIndex === undefined) {
      return undefined;
    }
    return this.getPointX(graphicDataIndex);
  }

  searchGraphicDataIndex(graphicIndex) {
    let leftBorder = 0;
    let rightBorder = this.graphicDataBuffer.length - 1;
    if (
      this.graphicDataIndex >= 0 &&
      this.graphicDataIndex < this.graphicDataBuffer.length - 1 &&
      this.graphicDataBuffer[this.graphicDataIndex + 1].graphicIndex < 0
    ) {
      rightBorder = this.graphicDataIndex;
    }
    while (leftBorder <= rightBorder) {
      let m = ((leftBorder + rightBorder) * 0.5) << 0;
      if (this.graphicDataBuffer[m].graphicIndex < graphicIndex) {
        leftBorder = m + 1;
      } else if (this.graphicDataBuffer[m].graphicIndex > graphicIndex) {
        rightBorder = m - 1;
      } else {
        return m;
      }
    }
    return undefined;
  }

  getLastColumnGraphicDataIndex(graphicIndex) {
    let bufferIndex = this.searchGraphicDataIndex(graphicIndex);
    if (bufferIndex === undefined) {
      return undefined;
    }
    while (bufferIndex < this.graphicDataBuffer.length && this.graphicDataBuffer[bufferIndex].graphicIndex == graphicIndex) {
      bufferIndex++;
    }
    if (bufferIndex == this.graphicDataBuffer.length && this.graphicDataBuffer[0].graphicIndex == graphicIndex) {
      bufferIndex = 0;
      while (this.graphicDataBuffer[bufferIndex].graphicIndex == graphicIndex) {
        bufferIndex++;
      }
    }
    bufferIndex--;
    return bufferIndex;
  }

  getFirstColumnGraphicDataIndex(graphicIndex) {
    let bufferIndex = this.searchGraphicDataIndex(graphicIndex);
    //console.log(`getGraphicDataIndex ${graphicIndex} ${bufferIndex}`);
    if (bufferIndex === undefined) {
      return undefined;
    }
    while (bufferIndex >= 0 && this.graphicDataBuffer[bufferIndex].graphicIndex == graphicIndex) {
      bufferIndex--;
    }
    if (bufferIndex < 0 && this.graphicDataBuffer[this.graphicDataBuffer.length - 1].graphicIndex == graphicIndex) {
      bufferIndex = this.graphicDataBufferLength - 1;
      if (this.graphicDataBuffer[bufferIndex] === undefined || graphicIndex === undefined) {
        this.graphicDataBuffer[bufferIndex] = undefined;
      }
      while (this.graphicDataBuffer[bufferIndex].graphicIndex == graphicIndex) {
        bufferIndex--;
      }
    }
    bufferIndex++;
    return bufferIndex;
  }
}
